import { render, staticRenderFns } from "./RELComboio.vue?vue&type=template&id=4cc658be&"
import script from "./RELComboio.vue?vue&type=script&lang=js&"
export * from "./RELComboio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports